import { QueryFunction } from '@tanstack/react-query';

import { handleErrors } from '@/shared/lib/errors';

import { apiWrapper } from '@/shared/api/main';

import { TCastingsClassifiers } from '@/shared/types/classifiers';
import { IErrorResponseData } from '@/shared/types/error';

/**
 * Получение классификаторов для кастингов
 * @param params - Объект ключа запроса.
 * @param params.queryKey - массив содержащий базовый url
 */
export const getCastingsClassifiers: QueryFunction<
  TCastingsClassifiers
> = async ({ queryKey }) => {
  const queryUrl = queryKey[0] as string;

  const response = await apiWrapper.get<
    TCastingsClassifiers,
    IErrorResponseData
  >(queryUrl);

  if (!response.ok) {
    const { mainError } = handleErrors(response);

    throw new Error(mainError);
  }

  return response.data || ({} as TCastingsClassifiers);
};
